// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-tooltip-panel {
  pointer-events: all !important;
}

.material-icons {
  color: #777b7e;
  cursor: help;
}

.tooltip-wrapper {
  display: grid;
  margin-left: 10px;
  align-items: center;
  white-space: pre-line;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/info-tooltip/info-tooltip.component.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;AACJ;;AAEA;EACI,cAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;AACJ","sourcesContent":[".mat-mdc-tooltip-panel {\n    pointer-events: all !important;\n}\n\n.material-icons {\n    color: #777b7e;\n    cursor: help;\n}\n\n.tooltip-wrapper {\n    display: grid;\n    margin-left: 10px;\n    align-items: center;\n    white-space: pre-line\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
